// Copyright © 2020 - Avanade, Inc.

import { SetStateAction, useState, useCallback } from "react";

export default function useLocalStorage<T>(
    key: string,
    initialValue: T
): [T, (arg: SetStateAction<T>, skipReactStore?: boolean) => void] {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = window.localStorage.getItem(key);
            return item ? ({ ...initialValue, ...JSON.parse(item) } as T) : initialValue;
        } catch (error) {
            console.error(error);
            return initialValue;
        }
    });
    const setValue = useCallback(
        (value: SetStateAction<T>, skipReactStore?: boolean) => {
            try {
                setStoredValue((v) => {
                    const newValue = typeof value === "function" ? (value as (prevState: T) => T)(v) : value;
                    window.localStorage.setItem(key, JSON.stringify(newValue));
                    return skipReactStore ? v : newValue;
                });
            } catch (error) {
                console.error(error);
            }
        },
        [key]
    );
    return [storedValue, setValue];
}
